import type { BetSlipPick, BetSlipHandoffPort } from '@s2w/core';
import { buildAddToSlipMessage } from './messaging.js';

export interface PostMessageTarget {
  postMessage(message: unknown, targetOrigin: string): void;
}

export interface CaesarsBetSlipHandoffOptions {
  readonly target: PostMessageTarget;
  readonly targetOrigin: string;
}

export class CaesarsBetSlipHandoff implements BetSlipHandoffPort {
  private readonly target: PostMessageTarget;
  private readonly targetOrigin: string;

  public constructor(options: CaesarsBetSlipHandoffOptions) {
    this.target = options.target;
    this.targetOrigin = options.targetOrigin;
  }

  public async handoff(picks: readonly BetSlipPick[]): Promise<void> {
    const selectionIds = picks.map((p) => String(p.externalOutcomeId));
    const message = buildAddToSlipMessage(selectionIds);
    // Trace outbound parent postMessages so they're visible in the iframe's
    // own console alongside the harness's `[inbound]` log. Styled prefix
    // makes the line easy to spot and grep by ("low6-s2w outbound").
    console.log(
      '%c[low6-s2w outbound]',
      'color: #5e9c64; font-weight: bold',
      message,
      '→',
      this.targetOrigin,
    );
    this.target.postMessage(message, this.targetOrigin);
  }
}
